export default "/img/DM.96f54bf8e792dec25143a6d6c85785ce.png";